import type { ProofStandardType } from "@/hooks/useProofStandards";

/**
 * Whether a storage/public URL points at video bytes. Uses path extension before `?`;
 * if ambiguous (e.g. truncated filename), uses optional proof standard type as a hint.
 */
export function isVideoMediaUrl(
  url: string,
  opts?: { standardProofType?: ProofStandardType },
): boolean {
  const path = url.split("?")[0].toLowerCase();
  if (/\.(jpe?g|png|gif|webp|heic|avif|bmp|tif|tiff)(\?|$)/i.test(path)) return false;
  if (/\.(mp4|webm|mov|m4v|mkv|mpeg|mpg|3gp|ogg|ogv)(\?|$)/i.test(path)) return true;
  if (opts?.standardProofType === "proof_video") return true;
  return false;
}

/** Pick a MediaRecorder mime the browser supports. */
export function pickVideoRecorderMime(): { mimeType: string; ext: string } {
  const candidates: Array<{ mimeType: string; ext: string }> = [
    { mimeType: "video/webm;codecs=vp8,opus", ext: "webm" },
    { mimeType: "video/webm;codecs=vp9,opus", ext: "webm" },
    { mimeType: "video/webm", ext: "webm" },
    { mimeType: "video/mp4", ext: "mp4" },
  ];
  if (typeof MediaRecorder === "undefined") {
    return candidates[0];
  }
  for (const c of candidates) {
    if (MediaRecorder.isTypeSupported(c.mimeType)) return c;
  }
  return candidates[0];
}
